import React, { useState } from 'react'
import classes from '../styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../../contexts/kato.context';
import { KatoType } from '../../../types/kato.types';
import { districtCards, getCardByName, oblastCards } from '../../../consts/kato.conts';
import { useUser } from '../../../contexts/user.context';

const DigitalPassport = () => {
    const { t } = useTranslation();
    const { currentLevel } = useKato();
    const { isModulePresent } = useUser();
    const [query, setQuery] = useState('');

    const includesName = (name: string) => {
        if (!query) return true;
        return t(`cards.${name.toLowerCase()}-card.title`).toLowerCase().includes(query.toLowerCase());
    }
    return (
        <div className={classes['digital-passport']}>
            <div className={classes['digital-passport__filters']}>
                <input type="text" value={query} onChange={(e) => setQuery(e.target.value)} placeholder='Поиск...' />
            </div>

            <div className={classes['digital-passport__grid']}>
                {
                    (currentLevel === KatoType.DISTRICT ? districtCards : oblastCards).map((card) =>
                    (isModulePresent(card) && includesName(card)) && (
                        <React.Fragment key={card}>
                            {getCardByName(card)}
                        </React.Fragment>
                    ))
                }
            </div>


        </div>
    )
}

export default DigitalPassport;
